<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23.0002C18.299 23.0002 23 18.2992 23 12.5002C23 6.70125 18.299 2.00024 12.5 2.00024C6.70101 2.00024 2 6.70125 2 12.5002C2 18.2992 6.70101 23.0002 12.5 23.0002ZM12.0737 17.5398L17.8419 8.53984L16.1581 7.46065L11.0647 15.4078L8.71154 13.0249L7.28846 14.4302L10.5203 17.7029L11.399 18.5927L12.0737 17.5398Z"
      fill="#2ED2BA"
    />
  </svg>
</template>

<style scoped lang="postcss"></style>
